import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'environments/environment';
import { TranslocoService } from '@ngneat/transloco';

/**
 * Intercept Outgoing requests for the translation
 *
 * @param req
 * @param next
 */
export const translocoInterceptor: HttpInterceptorFn = (req, next) => 
{
    
    const _translocoService = inject(TranslocoService);

    // Clone the request object
    let newReq = req.clone();

    // Add token and error management only for request targeting our backend
    if ( req.url.startsWith(environment.api) ) {
        // Request
        if ( _translocoService.getActiveLang() )
        {
            newReq = req.clone({
                headers: req.headers.set('Accept-Language', _translocoService.getActiveLang())
            });
        }
        // Response
        return next(newReq);
    } else {
        return next(newReq);
    }
}
